import script from "./luBillCancellation.vue?vue&type=script&setup=true&lang=ts"
export * from "./luBillCancellation.vue?vue&type=script&setup=true&lang=ts"

import "./luBillCancellation.vue?vue&type=style&index=0&id=d68e2fe0&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d68e2fe0"]])

export default __exports__